import React, { useEffect, useState } from "react";
import BodyWrapper from "../../../components/Wrapper/BodyWrapper";
import Header from "../../../components/Header/Header";
import ItemSummarySelector from "../../../components/Selector/ItemSummarySelector";
import { StockDataColumns } from "../../../assets/Columns/StockDataColumns";
import { useDispatch, useSelector } from "react-redux";
import { fetchItemStat } from "../../../store/Slices/ItemStatsSlice";
import SearchableTable from "../../../components/Tables/SearchableTable";
import { ItemStatsColumns } from "../../../assets/Columns/ItemStatsColumns";
import FetchingLoading from "../../../components/Loaders/FetchingLoading";

const user = JSON.parse(localStorage.getItem("user")) || {};
const branchId = user.branchId || "";

const ItemSummary = () => {
  const [selectedArticle, setSelectedArticle] = useState("");
  const [CurrentTab, setCurrentTab] = useState("Stock Stats");
  //   const [selectedArticle, setSelectedArticle] = useState({
  //     _id: `all_${branchId}`,
  //     name: "All",
  //   });

  const dispatch = useDispatch();
  const ItemStatState = useSelector((state) => state.ItemStatState);

  useEffect(() => {
    if (selectedArticle) dispatch(fetchItemStat(selectedArticle._id));
  }, [selectedArticle, dispatch]);

  useEffect(() => {
    if (ItemStatState?.data) {
      console.log(ItemStatState.data);
    }
  }, [ItemStatState]);

  const [SearchText, setSearchText] = useState("");
  return (
    <BodyWrapper>
      <Header
        title="Items-Summary"
        desc="Overview of your items summary."
      ></Header>
      <div className="mb-4">
        <ItemSummarySelector
          SelectedProduct={selectedArticle}
          setSelectedProduct={setSelectedArticle}
        />
      </div>

      {ItemStatState.loading === false &&
        (ItemStatState?.data?.trans || ItemStatState?.data.StockStats) &&
        ItemStatState?.data?.trans.length !== 0 && (
          <div className="mt-6 mb-6 grid grid-cols-4 max680:grid-cols-2 max440:grid-cols-1 gap-4">
            <div className="bg-card p-4 rounded-2xl border border-line shadow-soft">
              <h3 className="text-muted text-sm font-medium">In-Quantity</h3>
              <p className="text-2xl font-bold text-success">
                {ItemStatState.data.return.reduce(
                  (total, item) => total + (item.qty || 0),
                  0
                ) +
                  ItemStatState.data.StockStats.reduce(
                    (total, item) => total + (item.qty || 0),
                    0
                  )}
              </p>
            </div>
            <div className="bg-card p-4 rounded-2xl border border-line shadow-soft">
              <h3 className="text-muted text-sm font-medium">
                Sold-Quantity
              </h3>
              <p className="text-2xl font-bold text-danger">
                {ItemStatState.data.trans.reduce(
                  (total, item) => total + (item.qty || 0),
                  0
                )}
              </p>
            </div>
            <div className="bg-card p-4 rounded-2xl border border-line shadow-soft">
              <h3 className="text-muted text-sm font-medium">
                Return-Quantity
              </h3>
              <p className="text-2xl font-bold text-danger">
                {ItemStatState.data.return.reduce(
                  (total, item) => total + (item.qty || 0),
                  0
                )}
              </p>
            </div>
            <div className="bg-card p-4 rounded-2xl border border-line shadow-soft">
              <h3 className="text-muted text-sm font-medium">Quantity</h3>
              <p className="text-2xl font-bold text-ink">
                {ItemStatState.data.return.reduce(
                  (total, item) => total + (item.qty || 0),
                  0
                ) +
                  ItemStatState.data.StockStats.reduce(
                    (total, item) => total + (item.qty || 0),
                    0
                  ) -
                  ItemStatState.data.trans.reduce(
                    (total, item) => total + (item.qty || 0),
                    0
                  )}
              </p>
            </div>
          </div>
        )}

      {ItemStatState.loading && selectedArticle ? (
        <FetchingLoading />
      ) : (
        Array.isArray(ItemStatState?.data?.trans) &&
        ItemStatState.data.trans.length !== 0 &&
        Array.isArray(ItemStatState?.data?.StockStats) &&
        ItemStatState.data.StockStats.length !== 0 && (
          <div className="flex flex-col w-full gap-y-5">
            <div className="flex w-full mt-3 rounded-xl overflow-hidden bg-subtle border border-main">
              {["Stock Stats", "Sale", "Return"].map((tb) => {
                return (
                  <div
                    key={tb}
                    className={`text-center py-3 font-bold transition-Stock Stats ease-in-out duration-700 cursor-pointer w-full font-quicksand  ${
                      CurrentTab === tb ? "bg-main text-white" : "text-inkSecondary"
                    } `}
                    onClick={() => {
                      setCurrentTab(tb);
                    }}
                  >
                    {tb}
                  </div>
                );
              })}
            </div>
          </div>
        )
      )}

      {ItemStatState.loading === false &&
        CurrentTab === "Stock Stats" &&
        ItemStatState?.data &&
        Array.isArray(ItemStatState?.data.StockStats) && (
          <div className="mt-6">
            <h2 className="text-xl font-semibold text-white mb-8 p-4 w-full bg-main rounded-t-xl border-2 border-sec2">
              Stock Statistics
            </h2>
            <SearchableTable
              SearchPlaceholder={"Search Product Name..."}
              SearchText={SearchText}
              setSearchText={setSearchText}
              CurrentData={ItemStatState?.data.StockStats || [{}]}
              Columns={[
                {
                  id: "date",
                  title: "Date",
                  minWidth: 100,
                  align: "center",
                  type: "stock-stats",
                  format: (value) => value.toLocaleString("en-US"),
                },
                ...StockDataColumns.filter((col) => col.id !== "date"),
              ]}
            />
          </div>
        )}
      {ItemStatState.loading === false &&
        CurrentTab === "Sale" &&
        ItemStatState?.data &&
        Array.isArray(ItemStatState?.data.trans) && (
          <div className="mt-6">
            <h2 className="text-xl font-semibold text-white mb-8 p-4 w-full bg-main rounded-t-xl border-2 border-sec2">
              Sales Transactions
            </h2>
            <SearchableTable
              SearchPlaceholder={"Search Product Name..."}
              SearchText={SearchText}
              setSearchText={setSearchText}
              CurrentData={ItemStatState?.data.trans || [{}]}
              Columns={[
                {
                  id: "date",
                  title: "Date",
                  minWidth: 100,
                  align: "center",
                  type: "stock-stats",
                  format: (value) => value.toLocaleString("en-US"),
                },
                ...ItemStatsColumns.filter((col) => col.id !== "date"),
              ]}
            />
          </div>
        )}
      {ItemStatState.loading === false &&
        CurrentTab === "Return" &&
        ItemStatState?.data &&
        Array.isArray(ItemStatState?.data.return) && (
          <div className="mt-6">
            <h2 className="text-xl font-semibold text-white mb-8 p-4 w-full bg-main rounded-t-xl border-2 border-sec2">
              Return Transactions
            </h2>
            <SearchableTable
              SearchPlaceholder={"Search Product Name..."}
              SearchText={SearchText}
              setSearchText={setSearchText}
              CurrentData={ItemStatState?.data.return || [{}]}
              Columns={[
                {
                  id: "date",
                  title: "Date",
                  minWidth: 100,
                  align: "center",
                  type: "stock-stats",
                  format: (value) => value.toLocaleString("en-US"),
                },
                ...ItemStatsColumns.filter((col) => col.id !== "date"),
              ]}
            />
          </div>
        )}
    </BodyWrapper>
  );
};

export default ItemSummary;
